import { mapTravelerAdvanceDTO } from "./mapTravelerAdvanceDTO";
import { toDate } from "~/application/utils/date-functions";
import { mapAccountabilityExpenseDTO } from "./mapAccountabilityExpenseDTO";
import { mapViolatedPoliciesDTO } from "./mapViolatedPoliciesDTO";
import { OrderExpenseReportItemTypeDTO } from "../dtos/OrderDTO";
import { OrderExpenseReportItemType } from "~/application/types/entities/Order.type";
import { mapFinancialPendingDTO } from "./mapFinancialPendingDTO";

export function mapOrderExpenseReportItemTypeDTO(
  data?: OrderExpenseReportItemTypeDTO,
): OrderExpenseReportItemType | null {
  if (!data) return null;

  return {
    value: data.value,
    reports:
      data.reports?.map((expenseReport) => ({
        uuid: expenseReport.uuid,
        name: expenseReport.name,
        description: expenseReport.description,
        status: expenseReport.status,
        reportDate: new Date(expenseReport.report_date),
        reportAmount: parseFloat(expenseReport.report_amount),
        refundAmount: parseFloat(expenseReport.refund_amount),
        returnAmount: parseFloat(expenseReport.return_amount),
        advanceOrders: expenseReport.advance_orders.length
          ? expenseReport.advance_orders.map(mapTravelerAdvanceDTO)
          : [],
        accountabilityExpenses: expenseReport.accountability_expenses.length
          ? expenseReport.accountability_expenses.map(mapAccountabilityExpenseDTO)
          : [],
        createdAt: toDate(expenseReport.created_at),
        updatedAt: toDate(expenseReport.updated_at),
        violatedPolicies: expenseReport.violated_policies
          ? mapViolatedPoliciesDTO(expenseReport.violated_policies)
          : undefined,
        financialPending: expenseReport.financial_pending_amount
          ? mapFinancialPendingDTO(expenseReport.financial_pending_amount)
          : undefined,
      })) || null,
  };
}
